<template>
    <v-card>
        <v-list-item>
            <v-list-item-avatar color="grey">
                <v-icon dark>mdi-domain</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                {{ client.name }}
            </v-list-item-content>
        </v-list-item>
        <v-card-text>
            <p>
                Client Contact: {{ mainContact }}<br />
                Users: {{ userCount }}<br />
                Projects: {{ projectCount }}<br />
                Reports: {{ reportCount }}<br />
                Subscriptions:
                <span
                    v-if="client.stripe_plan"
                    class="d-inline-flex flex-wrap"
                    style="gap:0.2rem"
                >
                    <v-tooltip
                        v-for="(activeSubscription, index) in activeSubscriptions"
                        :key="index"
                        top
                    >
                        <template v-slot:activator="{ on }">
                            <v-chip
                                v-on="on"
                                :color="activeSubscription.color"
                                :text-color="activeSubscription.text"
                                x-small
                            >{{ activeSubscription.tier }}</v-chip>
                        </template>
                        <span>{{ activeSubscription.name }}</span>
                    </v-tooltip>
                </span>
                <span v-else>-</span>
            </p>
        </v-card-text>
        <v-card-actions>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="viewClientUsers">
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-btn>
                </template>
                <span>{{ userCount }} Users</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="viewClientProjects">
                        <v-icon>mdi-clipboard-list</v-icon>
                    </v-btn>
                </template>
                <span>{{ projectCount }} Projects</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="viewClientReports">
                        <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                </template>
                <span>{{ reportCount }} Reports</span>
            </v-tooltip>

            <v-spacer />

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="editClient">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="promptForDelete">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>Delete {{ client.name }}</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>
</template>

<script>
import { subscriptionStatusMap } from '@/subscriptionStatuses'

export default {
    name: 'ClientCard',
    props: {
        client: {
            type: Object,
            required: true,
        },
        stripePlans: {
            type: Array,
            required: true,
        },
    },
    computed: {
        reportCount: function() {
            return this.client.reports.length
        },
        projectCount: function() {
            return this.client.projects.length
        },
        userCount: function() {
            return this.client.users.length
        },
        mainContact: function() {
            if (!this.client.main_contact) {
                return 'None'
            } else {
                return this.client.main_contact.name
            }
        },
        tier: function() {
            const stripePlan = this.stripePlans.find(
                stripePlan => stripePlan.id === this.client.stripe_plan
            )

            return stripePlan ? stripePlan.name : '-'
        },
        activeSubscriptions() {
            const activeSubscriptions = []

            if (this.client.subscriptions.length) {
                const subscriptions = this.client.subscriptions.toSorted(
                    (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
                )
                subscriptions.forEach(subscription => {
                    // Excludes ended subscriptions
                    if (! subscription.ended) {
                        const status = subscriptionStatusMap[subscription.stripe_status]

                        activeSubscriptions.push({
                            ...status,
                            tier: subscription.name,
                        })
                    }
                })
            }

            // If there are no active subscriptions
            if (! activeSubscriptions.length) {
                activeSubscriptions.push({
                    tier: this.tier,
                    name: 'Not subscribed',
                    color: '#95a5a6',
                    text: '#ffffff',
                })
            }

            return activeSubscriptions
        },
    },
    methods: {
        loadForm(client) {
            this.$emit('loadClientForm', client)
        },
        viewClientReports() {
            this.$router.push({ path: `/reports/${this.client.id}` })
        },
        viewClientProjects() {
            this.$router.push({ path: `/projects/${this.client.id}` })
        },
        viewClientUsers() {
            this.$router.push({
                name: 'users',
                query: { client_id: this.client.id },
            })
        },
        promptForDelete() {
            this.$emit('delete-clicked', this.client)
        },
        editClient() {
            this.$emit('edit-clicked', this.client)
        },
    },
}
</script>
